import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'calculation',
      label: 'Calculation Defaults',
      icon: 'Calculator',
      description: 'Default values and calculation preferences'
    },
    {
      id: 'display',
      label: 'Display Preferences',
      icon: 'Eye',
      description: 'Formatting and visual options'
    },
    {
      id: 'export',
      label: 'Export Options',
      icon: 'Download',
      description: 'Report templates and export settings'
    }
  ];

  return (
    <div className="bg-surface border-b border-border">
      <div className="px-6">
        <nav className="flex space-x-8" aria-label="Settings tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === tab.id
                  ? 'border-primary text-primary' :'border-transparent text-text-secondary hover:text-foreground hover:border-border'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>
      
      {/* Mobile Tab Descriptions */}
      <div className="sm:hidden px-6 py-3 bg-muted">
        {tabs.map((tab) => (
          activeTab === tab.id && (
            <p key={tab.id} className="text-xs text-text-secondary">
              {tab.description}
            </p>
          )
        ))}
      </div>
    </div>
  );
};

export default SettingsTabs;